import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { CSSProperties } from "@material-ui/core/styles/withStyles";

export default makeStyles((theme: Theme) => {
  return {
    downloadButtons: {
      display: "flex",
      justifyContent: "center",
      alignContent: "center",
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    },
    uploadButtons: {
      display: "flex",
      justifyContent: "center",
      alignContent: "center",
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    },
    fileUploadArea: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    },
    loading: {
      display: "flex",
      justifyContent: "center",
      alignContent: "center",
      marginBottom: theme.spacing(2)
    },
    expansionPanel: {
      marginBottom: theme.spacing(1)
    },
    resultContainer: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    }
  };
});
